/* ==========================================================================
   KIND OF BLUE — conversion.js · la capa de la pasada 5.

   Vive aparte de kob.js a propósito: kob.js no se puede volver a subir
   entero con seguridad (34 KB a mano, sin CLI), y todo lo de acá es nuevo.
   Cuando haya CLI, se funde. Vanilla, sin dependencias.

     0 · eventos propios → Customer Events (Shopify.analytics.publish)
     1 · buscador sin resultados → botón "Pedirlo por encargo" + evento
     2 · Te lo conseguimos: prellenar desde la URL
     3 · ficha: barra de compra fija en móvil
     4 · colección: contador "N disponibles · M por encargo"
     5 · carrito: líneas que Shopify sacó por falta de stock
     6 · ficha: completar recomendaciones con las de Shopify, sólo con stock
   ========================================================================== */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clp = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));
  const raiz = () => window.Shopify?.routes?.root || '/';

  /* ---------------------------------------------------------------- 0 · eventos
     Cada evento llega a los píxeles personalizados de Customer Events con
     este nombre y estos datos. Ahí se reenvían a GA4 y Clarity — ver
     docs/analitica.md. Si Shopify.analytics no existe (editor de temas,
     preview), no pasa nada. */
  function publicar(nombre, datos) {
    try { window.Shopify?.analytics?.publish?.(nombre, datos || {}); } catch { /* sin analítica */ }
  }

  const handleDe = (el) => {
    const href = el.closest('.card, .chica, .pdp')?.querySelector('a[href*="/products/"]')?.getAttribute('href')
      || (location.pathname.includes('/products/') ? location.pathname : '');
    return (href.split('/products/')[1] || '').split(/[?#]/)[0];
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('.play');
    if (!b) return;
    publicar('preview_play', {
      handle: b.dataset.handle || handleDe(b),
      artista: b.dataset.artista || '',
      disco: b.dataset.album || '',
    });
  });

  const sin = $('[data-sin-resultado]');
  if (sin) publicar('busqueda_sin_resultado', { query: sin.dataset.sinResultado || '', desde: 'pagina' });
  if ($('.pide__ok')) publicar('encargo_enviado', { desde: new URLSearchParams(location.search).get('desde') || 'pagina' });
  if ($('.compra__ok')) publicar('aviso_stock_enviado', { handle: handleDe(document.body) });

  /* ------------------------------------------------- 1 · buscador sin resultado
     El overlay lo pinta kob.js. Acá se observa la lista de resultados y,
     cuando aparece el estado vacío, se le agrega el botón de encargo con lo
     escrito ya repartido en artista y disco. */
  function partir(q) {
    q = (q || '').trim();
    let m = q.split(/\s[-–]\s/);
    if (m.length >= 2) return { artista: m[0].trim(), disco: m.slice(1).join(' - ').trim() };
    m = q.split(/\sde\s/i);
    if (m.length >= 2) return { disco: m[0].trim(), artista: m[m.length - 1].trim() };
    return { artista: q, disco: '' };
  }
  const urlEncargo = (q) => {
    const { artista, disco } = partir(q);
    return `${raiz()}pages/te-lo-conseguimos?artista=${encodeURIComponent(artista)}&disco=${encodeURIComponent(disco)}&desde=busqueda`;
  };

  $$('kob-buscador').forEach((kb) => {
    const res = $('.busca__res', kb);
    const input = $('input[type="search"]', kb);
    if (!res || !input) return;
    new MutationObserver(() => {
      const vacio = $('.busca__empty', res);
      if (!vacio || vacio.dataset.listo) return;
      vacio.dataset.listo = '1';
      const q = input.value.trim();
      publicar('busqueda_sin_resultado', { query: q, desde: 'overlay' });
      const a = document.createElement('a');
      a.className = 'btn btn--tinta busca__encargo';
      a.href = urlEncargo(q);
      a.textContent = 'Pedirlo por encargo';
      vacio.appendChild(a);
    }).observe(res, { childList: true });
  });

  /* ------------------------------------------ 2 · Te lo conseguimos: prellenar */
  if ($('#encuentra-tu-disco')) {
    const p = new URLSearchParams(location.search);
    const pon = (sel, v) => { const el = $(sel); if (el && v && !el.value) el.value = v; };
    pon('#pide-artista', p.get('artista'));
    pon('#pide-disco', p.get('disco'));
    const origen = $('#pide-origen');
    if (origen && p.get('desde')) origen.value = p.get('desde');
    if (p.get('artista') || p.get('disco')) {
      const siguiente = [$('#pide-disco'), $('#pide-whatsapp')].find((el) => el && !el.value);
      siguiente?.focus();
    }
  }

  /* ---------------------------------------------- 3 · barra de compra fija
     Aparece cuando el botón "Agregar" real no está en pantalla (arriba o
     abajo). Refleja precio y variante; su botón dispara el submit del
     formulario, así que pasa por kob.js igual que el botón de siempre. */
  const form = $('form[data-pdp-form]');
  const barra = $('[data-barra]');
  if (form && barra && 'IntersectionObserver' in window) {
    const btn = form.querySelector('[type="submit"]');
    const addBarra = $('[data-barra-add]', barra);
    const precioBarra = $('[data-barra-precio]', barra);
    const fmtBarra = $('[data-barra-fmt]', barra);

    const mostrar = (si) => {
      if (si) barra.hidden = false;
      requestAnimationFrame(() => {
        barra.toggleAttribute('data-on', si);
        barra.setAttribute('aria-hidden', String(!si));
      });
    };
    new IntersectionObserver(([en]) => mostrar(!en.isIntersecting), { threshold: 0 }).observe(btn);

    addBarra?.addEventListener('click', () => { if (!btn.disabled) btn.click(); });

    /* espejo del precio y de la variante elegida */
    const precio = $('.pdp__price [data-precio]');
    if (precio && precioBarra) {
      new MutationObserver(() => { precioBarra.textContent = precio.textContent; }).observe(precio, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('click', (e) => {
      const v = e.target.closest('.pdp__var');
      if (!v || !fmtBarra) return;
      fmtBarra.textContent = v.textContent.split('·')[0].trim();
      const sinStock = v.hasAttribute('data-sold');
      if (addBarra) { addBarra.disabled = sinStock; addBarra.textContent = sinStock ? 'Sin stock' : (btn.textContent.trim() || 'Agregar'); }
    });
  }

  /* -------------------------------- 3b · el disco que asoma sigue al formato
     Discos con CD y LP: la ficha dibuja los dos soportes (Liquid) y acá se
     cambia cuál se ve al elegir la variante. Pedido de Karen. */
  const shotDual = $('.shot--dual[data-shot]');
  if (shotDual) {
    document.addEventListener('click', (e) => {
      const v = e.target.closest('.pdp__var');
      if (!v) return;
      const t = v.textContent.split('·')[0].toLowerCase();
      const esCd = /\bcd\b/.test(t) && !/\blp\b|vinil/.test(t);
      shotDual.classList.toggle('shot--cd', esCd);
      $('.shot__jacket', shotDual)?.classList.toggle('shot__jacket--cd', esCd);
    });
  }

  /* --------------------------------------------- 4 · contador de la colección
     Liquid no puede contar cuántos de la colección tienen stock (fuera de un
     paginate no ve la lista entera). Se pide la vista `conteo` de la misma
     colección con el tag stock-si puesto (o quitado, si ya estaba) y se arma
     "N disponibles · M por encargo". Las zonas se reemplazan por AJAX al
     filtrar, así que se vuelve a correr cada vez que cambia el contador. */
  const handleize = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  async function contar() {
    const el = $('[data-conteo]');
    if (!el || el.dataset.hecho) return;
    el.dataset.hecho = '1';
    const url = el.dataset.url;
    const tags = (el.dataset.tags || '').split(',').filter(Boolean);
    const solo = el.dataset.solo === '1';
    const total = parseInt(el.dataset.total, 10);
    const ruta = (lista) => (lista.length ? `${url}/${lista.map(handleize).join('+')}` : url);
    const base = tags.filter((t) => t !== 'stock:si');
    const pedir = async (lista) => parseInt((await (await fetch(`${ruta(lista)}?view=conteo`)).text()).trim(), 10);
    try {
      const [disp, tot] = solo ? [total, await pedir(base)] : [await pedir([...base, 'stock:si']), total];
      if (!Number.isFinite(disp) || !Number.isFinite(tot)) return;
      const enc = Math.max(0, tot - disp);
      el.innerHTML = `<b>${disp}</b> disponibles${enc ? ` <span class="res__enc">· ${enc} por encargo</span>` : ''}`;
      const c = $('[data-conteo-disponibles]');
      if (c) c.textContent = disp;
    } catch { /* el contador de Liquid queda como está */ }
  }
  contar();
  const zonaConteo = $('[data-zona="conteo"]');
  if (zonaConteo) new MutationObserver(contar).observe(zonaConteo, { childList: true });

  /* -------------------------------------- 5 · carrito: lo que Shopify sacó
     Cuando una línea del carrito se queda sin stock, Shopify la quita del
     objeto `cart` que pinta el drawer, pero el checkout igual avisa que la
     eliminó. Resultado: la persona ve dos discos en la bolsa y en el checkout
     le dicen que había un tercero. Acá se compara lo que dice /cart.js con
     las líneas pintadas y, si falta alguna, se muestra en gris con "Se agotó
     mientras lo tenías en la bolsa" y las dos salidas: pedirlo por encargo o
     quitarlo. No desaparece sola. */
  document.addEventListener('cart:updated', (e) => {
    const cart = e.detail;
    const caja = $('[data-cartd-agotados]');
    if (!cart || !caja) return;
    const pintadas = new Set($$('[data-linea-key]').map((el) => el.dataset.lineaKey));
    const faltan = (cart.items || []).filter((it) => !pintadas.has(it.key));
    caja.innerHTML = faltan.map((it) => `
      <div class="cartd__agotado" data-key="${esc(it.key)}">
        <b>${esc(it.product_title)}</b>
        <span>Se agotó mientras lo tenías en la bolsa.</span>
        <span class="acciones">
          <a href="${esc(it.url)}#solicitar">Pedirlo por encargo</a>
          <button type="button" data-quitar-agotado="${esc(it.key)}">Quitar</button>
        </span>
      </div>`).join('');
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quitar-agotado]');
    if (!b) return;
    b.disabled = true;
    await fetch(`${raiz()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.dataset.quitarAgotado, quantity: 0 }),
    }).catch(() => {});
    b.closest('.cartd__agotado')?.remove();
  });

  /* ------------------------------------- 6 · recomendaciones: completar
     Si Liquid no juntó cuatro con stock, se pide la MISMA sección por la
     Section Rendering API de recomendaciones: devuelve las cards ya pintadas
     con el snippet de siempre, filtradas por stock. Se descartan las que ya
     están en pantalla. */
  const meson = $('[data-meson]');
  if (meson && parseInt(meson.dataset.faltan, 10) > 0) {
    const grid = $('[data-meson-grid]', meson);
    const vistos = meson.dataset.vistos || '';
    fetch(`${raiz()}recommendations/products?section_id=${encodeURIComponent(meson.dataset.seccion)}&product_id=${meson.dataset.producto}&limit=10&intent=related`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html || !grid) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        let faltan = parseInt(meson.dataset.faltan, 10);
        let puestas = 0;
        for (const card of $$('[data-meson-extra] .card', doc)) {
          if (faltan <= 0) break;
          const id = card.dataset.producto;
          if (!id || vistos.includes(`|${id}|`) || card.classList.contains('card--agotado')) continue;
          card.setAttribute('data-in', '');
          grid.appendChild(card);
          faltan -= 1;
          puestas += 1;
        }
        if (puestas && meson.hidden) {
          meson.hidden = false;
          $$('.rv', meson).forEach((el) => el.setAttribute('data-in', ''));
        }
      })
      .catch(() => {});
  }
})();
